import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation-close",
  "use": "navigation-close-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"navigation-close\">\n    <path d=\"M26 10 10 26m16 0L10 10\" stroke=\"#4C4C4C\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol